import { Helmet } from "react-helmet-async";
import { buildCanonicalUrl } from "@/lib/utils";

/**
 * HreflangTags Component
 * 
 * Aggiunge i tag hreflang per il targeting internazionale.
 * Indica a Google che il sito è in italiano e targetizza parlanti italiani globalmente.
 * 
 * @param currentPath - Il path della pagina corrente (es: "/", "/chi-sono", "/blog")
 */
export function HreflangTags({ currentPath }: { currentPath: string }) {
  const normalisedPath = currentPath === "/"
    ? "/"
    : currentPath.endsWith("/")
      ? currentPath
      : `${currentPath}/`;
  const fullUrl = buildCanonicalUrl(normalisedPath);

  return (
    <Helmet>
      {/* Lingua italiana unica per tutte le pagine */}
      <link rel="alternate" hrefLang="it" href={fullUrl} />
    </Helmet>
  );
}
